const StateOperationTypes = Object.freeze({
  append: "APPEND",
  set: "SET",
  remove: "REMOVE",
  replace: "REPLACE",
});

export default StateOperationTypes;
